module.exports = __webpack_public_path__ + "static/media/flag.b6bb452f.svg";